import { useDispatch, useSelector } from "react-redux";
import { CreditCard } from "lucide-react";
import { updateField } from "../../../../redux/slices/employee-slice";
import { Select, Input } from "antd";

const Payment = () => {
  const dispatch = useDispatch();
  const form = useSelector((state) => state.employeeForm);

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateField({ name, value }));
  };

  const handleSelectChange = (value, name) => {
    dispatch(updateField({ name, value }));
  };

  const paymentOptions = [
    { value: "bank", label: "Bank Transfer" },
    { value: "cash", label: "Cash" },
    { value: "cheque", label: "Cheque" },
  ];

  return (
    <div className="flex items-start justify-between bg-white px-4">
      <div className="flex flex-col gap-3 mt-1">
        <CreditCard className="h-7 w-7 text-active-color stroke-1" />
        <h4 className="font-semibold text-md">Payment Method</h4>
        <p className="text-gray-400 text-md -mt-2">
          Fill in the employee's payment details.
        </p>
      </div>
      <div className="bg-form-bg w-lg rounded-md px-4 flex flex-col gap-6 py-8 mt-5">
        <div className="flex flex-col gap-1 col-span-6">
          <label htmlFor="paymeny_type" className="text-md">
            Salary Payment Method
          </label>
          <Select
            className="w-full"
            placeholder="Select Payment Method"
            name="paymeny_type"
            onChange={(value) => handleSelectChange(value, "paymeny_type")}
            value={form.paymeny_type}
            options={paymentOptions}
          />
        </div>
        <div className="col-span-6"></div>
        {form.paymeny_type === "bank" && (
          <>
            <div className="flex flex-col gap-1 col-span-6">
              <label htmlFor="bank_name" className="text-md">
                Bank Name
              </label>
              <Input
                placeholder="Bank Name"
                name="bank_name"
                value={form.bank_name}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col gap-1 col-span-6">
              <label htmlFor="account_title" className="text-md">
                Account Title
              </label>
              <Input
                placeholder="Account Title"
                name="account_title"
                value={form.account_title}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col gap-1 col-span-6">
              <label htmlFor="account_number" className="text-md">
                Account Number
              </label>
              <Input
                placeholder="Account Number"
                name="account_number"
                value={form.account_number}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col gap-1 col-span-6">
              <label htmlFor="ibn_number" className="text-md">
                IBAN Number
              </label>
              <Input
                placeholder="IBAN Number"
                name="ibn_number"
                value={form.ibn_number}
                onChange={handleChange}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Payment;
